import { GUEST_REASONS } from 'src/features/cards/types';
import { cardMessages } from 'src/features/cards/utils/messages';
import { statisticsMessages } from 'src/features/statistics/utils';

import type { CURRENCIES } from 'src/features/payStations/types';

export enum PAYMENT_TYPE {
    CARD = 'С карта',
    BANK = 'По банка',
    ONLINE = 'Онлайн',
    ONLINE_PAYMENT = 'Онлайн плащане',
    CASH = 'В брой',
    BLINK = 'Блинк',
    BLINK_PAYMENT = 'Блинк плащане',
}
type StatisticTotalPaymentDetails = {
    code: string;
    name: string;
    price_no_vat: number;
    price_vat_only: number;
    price_total: number;
    currency: CURRENCIES;
};

export const PAYMENT_TYPE_MAP: Partial<Record<PAYMENT_TYPE, { id: string; defaultMessage: string }>> = {
    [PAYMENT_TYPE.CARD]: cardMessages.withCard,
    [PAYMENT_TYPE.BANK]: cardMessages.paymentTypeBank,
    [PAYMENT_TYPE.ONLINE_PAYMENT]: cardMessages.online,
    [PAYMENT_TYPE.ONLINE]: cardMessages.online,
    [PAYMENT_TYPE.CASH]: cardMessages.cash,
    [PAYMENT_TYPE.BLINK]: cardMessages.blink,
    [PAYMENT_TYPE.BLINK_PAYMENT]: cardMessages.blink,
};

export type StatisticTotalPayments = {
    result_type: string;
    period_start: string;
    period_end: string;
    details: StatisticTotalPaymentDetails[];
};

export type StatisticPaymentDetails = {
    id: string;
    identifier: string;
    characters: string;
    payment_datetime: string;
    event_type: string;
    event_name: string;
    site_code: string;
    site_name: string;
    working_place_code: string;
    working_place_name: string;
    operator_id: string;
    operator_name: string;
    unp_by_software: string;
    unp_by_fiscal: string;
    invoice_number: string;
    invoice_date: string;
    item_code: string;
    item_name: string;
    payment_type_code: string;
    payment_type_name: string;
    item_quantity: number;
    price_no_vat: number;
    price_vat_only: number;
    price_total: number;
    vat: number;
    workingplace_id: string;
    currency: CURRENCIES;
};

export enum PAYMENT_EXPORT_PROPS {
    IDENTIFIER = 'identifier',
    PAYMENT_DATETIME = 'payment_datetime',
    TIME = 'time',
    ITEM_NAME = 'item_name',
    PAYMENT_TYPE_NAME = 'payment_type_name',
    ITEM_QUANTITY = 'item_quantity',
    PRICE_NO_VAT = 'price_no_vat',
    PRICE_VAT_ONLY = 'price_vat_only',
    PRICE_TOTAL = 'price_total',
    CURRENCY = 'currency',
    FISCAL_NOTE_NUMBER = 'unp_by_fiscal',
    OPERATOR_NAME = 'operator_name',
    WORKING_PLACE_NAME = 'working_place_name',
    EVENT_NAME = 'event_name',
}

export const PAYMENT_EXPORT_MESSAGES_MAP = {
    [PAYMENT_EXPORT_PROPS.IDENTIFIER]: cardMessages.cardNumber,
    [PAYMENT_EXPORT_PROPS.PAYMENT_DATETIME]: statisticsMessages.date,
    [PAYMENT_EXPORT_PROPS.TIME]: statisticsMessages.hour,
    [PAYMENT_EXPORT_PROPS.ITEM_NAME]: statisticsMessages.category,
    [PAYMENT_EXPORT_PROPS.PAYMENT_TYPE_NAME]: cardMessages.paymentMethod,
    [PAYMENT_EXPORT_PROPS.ITEM_QUANTITY]: statisticsMessages.quantity,
    [PAYMENT_EXPORT_PROPS.PRICE_NO_VAT]: statisticsMessages.withoutVat,
    [PAYMENT_EXPORT_PROPS.PRICE_VAT_ONLY]: cardMessages.vatAmount,
    [PAYMENT_EXPORT_PROPS.PRICE_TOTAL]: statisticsMessages.withVat,
    [PAYMENT_EXPORT_PROPS.CURRENCY]: statisticsMessages.currency,
    [PAYMENT_EXPORT_PROPS.FISCAL_NOTE_NUMBER]: statisticsMessages.fiscalNoteNumber,
    [PAYMENT_EXPORT_PROPS.OPERATOR_NAME]: cardMessages.cardTypeOperator,
    [PAYMENT_EXPORT_PROPS.WORKING_PLACE_NAME]: statisticsMessages.workingPlace,
    [PAYMENT_EXPORT_PROPS.EVENT_NAME]: statisticsMessages.eventType,
};

export type StatisticManualPointOpens = {
    id: number;
    event_datetime: string;
    parking_id: string;
    parking_name: string;
    point_name: string;
    operator_id: string;
    operator_name: string;
    open_reason: string;
    photo_path: string;
};

export type PaymentType = {
    id: string;
    name: PAYMENT_TYPE;
};

export type PaymentDetailsData = {
    title: string;
    value: string | number | null | undefined;
    control: any;
};
